module.exports = __webpack_public_path__ + "static/media/logo_kwick_comfort_call.5f3f3c84.jpg";